import Modal from "react-modal";
import "./ModalTemplate.scss";
import classNames from "classnames";
import Icon from "../Icon/Icon";

const ModalTemplate = ({onClose, title, icon, children, footerActions, className, footerClassName}) => {
    return (
        <Modal
            beforeClose={false}
            onRequestClose={(event) => {
                if (event.type === 'keydown' && event.keyCode === 27) return;
                onClose();
            }}
            shouldCloseOnOverlayClick={false}
            className={classNames("base", className)}
            overlayClassName="overlay"
            isOpen={true}
        >
            <div className={classNames("header", className)}>
                <Icon svg={icon}/>
                {title}
            </div>

            <div className="body">
                {children}
            </div>

            {footerActions && (
                <div className={classNames("footer", footerClassName)}>
                    {footerActions}
                </div>
            )}
        </Modal>
    );
};

export default ModalTemplate;